// @flow

import { toArray, safeGet, isNullOrUndefined, nonNullOrThrow } from "./Util";

export const BUILDER_PREVIEW_QUERY_PARAM = "__wispform_builder_preview";

export function appendQueryParameter(
  url: string,
  name: string,
  value: string
): string {
  const hashIndex = url.indexOf("#");
  const baseUrl = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
  const hash = hashIndex >= 0 ? url.slice(hashIndex) : "";
  const separator = baseUrl.includes("?")
    ? /[?&]$/.test(baseUrl)
      ? ""
      : "&"
    : "?";

  return `${baseUrl}${separator}${encodeURIComponent(
    name
  )}=${encodeURIComponent(value)}${hash}`;
}

export function appendBuilderPreviewMarker(url: string): string {
  return appendQueryParameter(url, BUILDER_PREVIEW_QUERY_PARAM, "1");
}

export function isBuilderPreviewRequest(): boolean {
  return (
    searchStringToMap(window.location.search)[BUILDER_PREVIEW_QUERY_PARAM] ===
    "1"
  );
}

export function isReservedUrlParam(paramName: ?string): boolean {
  return paramName === BUILDER_PREVIEW_QUERY_PARAM;
}

export function isFormPage() {
  const path = safeGet(_ => window.location.pathname.split("/")[1]);
  if (
    path == "form" ||
    path == "workspace" ||
    path == "try" ||
    path == "test" ||
    path == "view"
  ) {
    return false;
  } else {
    // form ID should always be 8
    return path && path.length === 8;
  }
}

export function constructURL(
  origin: string,
  pathName: string,
  params: { [string]: string }
): string {
  const paramList = Object.keys(params)
    .map(name => `${name}=${encodeURIComponent(params[name])}`)
    .join("&");
  return `${origin}${pathName}?${paramList}`;
}

export function searchStringToMap(searchString: string): { [string]: string } {
  try {
    const searchStringWithoutQuestionMark =
      searchString[0] === "?" ? searchString.slice(1) : searchString;
    return JSON.parse(
      '{"' +
        searchStringWithoutQuestionMark
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}',
      function (key, value) {
        return key === "" ? value : decodeURIComponent(value);
      }
    );
  } catch (error) {
    return {};
  }
}

export function isUrlParamAllowed(paramName: ?string) {
  if (isNullOrUndefined(paramName)) {
    return false;
  }
  return (
    !isReservedUrlParam(paramName) &&
    nonNullOrThrow(paramName).match("^[A-Za-z0-9-_.!~*'()]*$")
  );
}
